import { render, staticRenderFns } from "./TourIntro.vue?vue&type=template&id=1a97ee42"
import script from "./TourIntro.vue?vue&type=script&lang=js"
export * from "./TourIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports